<mc-chart type="doughnut" [options]="options" [data]="data"></mc-chart>
<div class="mc-doughnut-chart-hole" *ngIf="(hole$ | async) as hole">
  <ng-container *ngIf="holeTemplate" [ngTemplateOutlet]="holeTemplate" [ngTemplateOutletContext]="{$implicit: { label: hole.label, value: hole.value }}"></ng-container>
</div>